import React from 'react';
import './Cards.css';
import CardItem from './CardItem';


function Cards() {
  return (
    <div className='cards'>
      <h1>Apskati mūsu piedāvājumus!</h1>
      <div className='cards__container'>
        <div className='cards__wrapper'>
          <ul className='cards__items'>
            <CardItem
              src='images/card3.jpg'
              text='Čarteru ceļojumu'
              label='Piedzīvojumi'
              path='/charter'
            />
            <CardItem
              src='images/card1.jpg'
              text='Individuāla ceļojuma plānošana'
              label='Privātpersonām'
              path='/kontakti'
            />
          </ul>
          <ul className='cards__items'>
            <CardItem
              src='images/card4.jpg'
              text='Atpūtas un motivēšanas ceļojumu organizēšana kolektīviem'
              label='Uzņēmumiem'
              path='/kontakti'
            />
            <CardItem
              src='images/card2.jpg'
              text='Kāzu ceļojumu plānošana un organizēšana'
              label='Travel & Love'
              path='/kontakti'
            />
            <CardItem
              src='images/card5.jpg'
              text='Luksusa tipa ceļojumu organizēšana'
              label='VIP'
              path='/kontakti'
            />
          </ul>
        </div>
      </div>
    </div>
  );
}

export default Cards;